import React from 'react';
import { z } from 'zod';
import { Input } from '@/components/ui/input';
import { useFormContext } from 'react-hook-form';
import { QuestionData } from '../types';

interface DateFieldProps {
  question: QuestionData;
  disabled?: boolean;
}

const DateFieldComponent: React.FC<DateFieldProps> = ({
  question,
  disabled,
}) => {
  const { register } = useFormContext();
  return (
    <Input
      {...register(question.slug)}
      type="date"
      className="w-full"
      disabled={disabled}
    />
  );
};

const createDateSchema = (question: QuestionData): z.ZodTypeAny => {
  const schema = z.string().refine(val => {
    if (!val) return true;
    const date = new Date(val);
    return !isNaN(date.getTime());
  }, 'Invalid date format');

  if (question.required) {
    return schema.refine(val => val !== '', {
      message: 'This field is required',
    });
  }
  return schema.optional();
};

const getDefaultValue = (): string => '';

export const DateField = {
  component: DateFieldComponent,
  createSchema: createDateSchema,
  getDefaultValue,
};
